import * as fetchVisitorParking from "./fetchVisitorParking";
import * as visitorParking from "./visitorParking";
import { initialState as visitorParkingInitialState, VisitorParkingRequestInfoState } from "./visitorParking";
import { initialState as fetchVisitorParkingInitialState, FetchVisitorParkingInfoState } from "./fetchVisitorParking";
import reduceReducers from "reduce-reducers";


export const Types: { [key: string]: any } = {
    ...fetchVisitorParking.Types,
    ...visitorParking.Types
};

export const Actions: { visitorParking: typeof visitorParking.Actions, fetchVisitorParking: typeof fetchVisitorParking.Actions } = {
    visitorParking: visitorParking.Actions,
    fetchVisitorParking: fetchVisitorParking.Actions
};

export const visitorParkingRequestReducer = reduceReducers<VisitorParkingRequestInfoState>(
    visitorParkingInitialState,
    visitorParking.default as any
);

export const fetchVisitorParkingRequestReducer = reduceReducers<FetchVisitorParkingInfoState>(
    fetchVisitorParkingInitialState,
    fetchVisitorParking.default as any
);

export default {
    visitorParking: visitorParkingRequestReducer,
    fetchVisitorParking: fetchVisitorParkingRequestReducer
};